import { DEFAULT_ODDS_TYPE } from '../../../constants';
import { Locale } from '../../../types';
import { DateTimeSettings } from '../formatters/date-time/types';
import { NumberSettings } from '../formatters/number/types';
import { TIMEZONE_UTC } from './constants';
import type { Options } from './types';

const DEFAULT_OPTIONS: Options = {
    disableFallbacks: true,
}

const DEFAULT_DATETIME_SETTINGS: DateTimeSettings = {
    timeZone: TIMEZONE_UTC,
    timeZoneOffset: 0,
    useTimeZoneOffset: true,
    defaultFormat: 'dateTimeShort',
    friendlyModeMinOffset: 0,
    friendlyModeMaxOffset: 1,
}

const DEFAULT_NUMBER_SETTINGS: NumberSettings = {
    currency: 'RUB',
    oddsType: DEFAULT_ODDS_TYPE,
    defaultFormat: 'number',
    hideCurrencySymbol: false,
}

const DEFAULT_CULTURES: Record<Locale, string> = {
    en: 'en-IE'
};


export {
    DEFAULT_OPTIONS,
    DEFAULT_DATETIME_SETTINGS,
    DEFAULT_NUMBER_SETTINGS,
    DEFAULT_CULTURES,
}
